import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

// D8.7.4 — Diálogo ProfDialog (presentacional).
export default function ProfDialog({ profDialogOpen, setProfDialogOpen, profDialogMode, profDialogData, setProfDialogData, profDialogSaving, handleSaveProfDialog, users }) {
  return (
          <Dialog open={profDialogOpen} onClose={() => setProfDialogOpen(false)} maxWidth="sm" fullWidth>
            <DialogTitle>
              {profDialogMode === "create" ? "Agregar miembro del equipo" : "Editar miembro del equipo"}
            </DialogTitle>
            <DialogContent>
              <TextField
                label="Nombre completo"
                fullWidth
                margin="dense"
                variant="outlined"
                value={profDialogData.name}
                onChange={(e) => setProfDialogData(p => ({ ...p, name: e.target.value }))}
              />
              <TextField
                label="Rol / Cargo"
                fullWidth
                margin="dense"
                variant="outlined"
                placeholder="Ej: Docente, Terapeuta, Asesor…"
                value={profDialogData.roleLabel}
                onChange={(e) => setProfDialogData(p => ({ ...p, roleLabel: e.target.value }))}
              />
              <TextField
                label="Especialidad(es)"
                fullWidth
                margin="dense"
                variant="outlined"
                placeholder="Ej: Matemáticas · Física"
                value={profDialogData.specialty}
                onChange={(e) => setProfDialogData(p => ({ ...p, specialty: e.target.value }))}
              />
              <FormControl fullWidth margin="dense" variant="outlined">
                <InputLabel>Vincular usuario del sistema</InputLabel>
                <Select
                  value={profDialogData.whatsappUserId}
                  onChange={(e) => setProfDialogData(p => ({ ...p, whatsappUserId: e.target.value }))}
                  label="Vincular usuario del sistema"
                >
                  <MenuItem value="">Sin asignar</MenuItem>
                  {users.map((u) => (
                    <MenuItem key={u.id} value={u.id}>{u.name} ({u.email})</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setProfDialogOpen(false)}>Cancelar</Button>
              <Button
                onClick={handleSaveProfDialog}
                disabled={profDialogSaving || !profDialogData.name.trim()}
                color="primary"
                variant="contained"
              >
                {profDialogSaving ? "Guardando…" : "Guardar"}
              </Button>
            </DialogActions>
          </Dialog>
  );
}
